import React from 'react';
import { products } from '../data/products';
import '../styles/ProductsSection.css';

const ProductsSection = () => {
  return (
    <div id="products" className="section">
      <div className="header-row">
        <div className="text-block">
          <h2 id="products-title-html">INDUSTRY MAX PRODUCTS</h2>
          <p>
            Industry Max offers comprehensive technology solutions designed to enhance your business operations. Our product portfolio 
            includes advanced <strong>fire alarm systems</strong> for complete building protection, sophisticated <strong>access control</strong> 
            systems for secure facility management, reliable <strong>VOIP</strong> communication solutions, high-definition <strong>CCTV</strong> 
            surveillance systems, efficient <strong>solar inverters</strong> for sustainable energy, and premium <strong>audio systems</strong> 
            for professional sound solutions. Each product is engineered with cutting-edge technology and backed by our expert support team.
          </p>
        </div>

        <div className="cta">
          <a className="btn" href="/coming-soon/">VIEW MORE</a>
        </div>
      </div>

      <div className="products">
        {products.map((product) => (
          <div key={product.id} className="product">
            <a href={product.link}>
              <img src={product.image} alt={product.name} loading="lazy" />
            </a>
            <h3><a href={product.link}>{product.name}</a></h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductsSection;
